import React from 'react';

const TimelineTransactionIcon = ({ fill = 'grey'}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 10.5"
      xmlSpace="preserve"
      className="card-icon"
    >
      <title>Transaction</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-862.000000, -1555.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Transaction-Attached" transform="translate(317.000000, 650.000000)">
                <g id="Icon">
                  <g id="Avatar">
                    <path
                      id="Shape"
                      fill={fill}
                      d="M24.9,21H14.1c-0.6,0-1.1,0.5-1.1,1.1v8.3c0,0.6,0.5,1.1,1.1,1.1h10.8c0.6,0,1.1-0.5,1.1-1.1
                      v-8.3C26,21.5,25.5,21,24.9,21z M14.1,21.8h10.8c0.2,0,0.4,0.2,0.4,0.4v1.1H13.7v-1.1C13.7,21.9,13.9,21.8,14.1,21.8z
                      M24.9,30.8H14.1c-0.2,0-0.4-0.2-0.4-0.4v-4.9h11.6v4.9C25.3,30.6,25.1,30.8,24.9,30.8z M17.3,28.8V29c0,0.2-0.1,0.3-0.3,0.3
                      h-1.6c-0.1,0-0.3-0.1-0.3-0.3v-0.2c0-0.2,0.1-0.3,0.3-0.3h1.6C17.2,28.5,17.3,28.6,17.3,28.8z M21.7,28.8V29
                      c0,0.2-0.1,0.3-0.3,0.3h-3.1c-0.1,0-0.3-0.1-0.3-0.3v-0.2c0-0.2,0.1-0.3,0.3-0.3h3.1C21.5,28.5,21.7,28.6,21.7,28.8z"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>

  );
};

export default TimelineTransactionIcon;
